require("!!/Users/eberdellima/php/venue/node_modules/script-loader/addScript.js")(require("!!/Users/eberdellima/php/venue/node_modules/raw-loader/index.js!/Users/eberdellima/php/venue/node_modules/babel-loader/lib/index.js??ref--2!/Users/eberdellima/php/venue/public/js/lib/owl.carousel.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./public/js/lib/owl.carousel.min.js
// module id = 411
// module chunks = 0 1